import { createIcon } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
export var CalendarIcon = createIcon({
  displayName: 'CalendarIcon',
  viewBox: '0 0 32 32',
  path: /*#__PURE__*/_jsx("path", {
    d: "M24.6662 6.00039H22.6657V4H21.3325V6.00039H10.6663V4H9.33307V6.00039H7.33376C5.49563 6.00039 4 7.49595 4 9.33399V24.6664C4 26.5044 5.49563 28 7.33376 28H24.6662C26.5044 28 28 26.5044 28 24.6664V12.6664V11.3332V9.33281C27.9988 7.49477 26.5032 6.00039 24.6662 6.00039ZM26.6655 24.6652C26.6655 25.7673 25.7684 26.6644 24.6662 26.6644H7.33376C6.23041 26.6644 5.33327 25.7673 5.33327 24.6652V12.6664H26.6655V24.6652ZM26.6655 11.3332H5.33327V9.33281C5.33327 8.22951 6.23041 7.33241 7.33376 7.33241H9.33426V8.66561H10.6663V7.3336H21.3325V8.6668H22.6657V7.3336H24.6662C25.7684 7.3336 26.6655 8.22951 26.6655 9.33281V11.3332Z",
    fill: "currentColor"
  })
});
//# sourceMappingURL=CalendarIcon.js.map